/* ──────────────────────────────────────────────────────────────
 *  Training Data API — fetch scatter plot data & parameter ranges
 * ────────────────────────────────────────────────────────────── */

import axiosClient from './axiosClient';
import type { BushingType } from '@/types/bushing';
import type { SampleRow } from '@/types/sample';

/** Response from GET /training-data/:bushingType */
export interface TrainingDataResponse {
  columns: string[];
  data: SampleRow[];
}

/** Parameter range shape */
export interface ParamRange {
  min: number;
  max: number;
}

/** Response from GET /training-data/:bushingType/ranges */
export type ParameterRangesResponse = Record<string, ParamRange>;

/** Fetch training samples for a given bushing type. */
export async function fetchTrainingData(
  bushingType: BushingType,
): Promise<TrainingDataResponse> {
  const { data } = await axiosClient.get<TrainingDataResponse>(
    `/training-data/${encodeURIComponent(bushingType)}`,
  );
  return data;
}

/** Fetch parameter min/max ranges for a given bushing type. */
export async function fetchParameterRanges(
  bushingType: BushingType,
): Promise<ParameterRangesResponse> {
  const { data } = await axiosClient.get<ParameterRangesResponse>(
    `/training-data/${encodeURIComponent(bushingType)}/ranges`,
  );
  return data;
}
